import React, { ReactNode, Suspense, MouseEvent } from 'react';
import { Disclosure, Transition } from '@headlessui/react';
import cx from 'classnames';
import { twMerge } from 'tailwind-merge';

export default function Accordion({
  children,
  className,
  header = null,
  defaultOpen = false,
  index = 0,
}: {
  header: string | ReactNode;
  className?: string;
  index?: number;
  children: ReactNode;
  defaultOpen?: boolean;
}) {
  const handleFocus = (event: MouseEvent<HTMLDivElement>) => {
    const noneFocusedPanels = document.querySelectorAll('.disclosure');
    noneFocusedPanels.forEach(node => {
      node.classList.remove('disclosure-focused');
      node.classList.add('disclosure-blured');
    });

    event.currentTarget.classList.remove('disclosure-blured');
    event.currentTarget.classList.add('disclosure-focused');
  };

  const handleMouseLeave = () => {
    const noneFocusedPanels = document.querySelectorAll('.disclosure');
    noneFocusedPanels.forEach(node => {
      node.classList.remove('disclosure-focused');
      node.classList.remove('disclosure-blured');
    });
  };

  return (
    <Disclosure defaultOpen={defaultOpen} as="div" onClick={handleFocus} onMouseLeave={handleMouseLeave} className="disclosure w-full">
      {({ open }) => (
        <>
          <Disclosure.Button
            className={twMerge('flex w-full justify-between  px-4 py-2 text-left text-sm border-t-0 font-medium items-center', className, index > 0 ? 'mt-2' : '')}
          >
            {header}
            <i className={cx('ri-arrow-down-s-line ml-2', open ? 'rotate-180 transform' : '')} />
          </Disclosure.Button>
          <Transition
            show={!!open}
            enter="transition duration-100 ease-out"
            enterFrom="transform scale-95 opacity-0"
            enterTo="transform scale-100 opacity-100"
            leave="transition duration-75 ease-out"
            leaveFrom="transform scale-100 opacity-100"
            leaveTo="transform scale-95 opacity-0"
          >
            <Suspense fallback={null}>
              <Disclosure.Panel className="panel text-gray-500  border-y-0 rounded-md bg-inherit  text-sm ">{children}</Disclosure.Panel>
            </Suspense>
          </Transition>
        </>
      )}
    </Disclosure>
  );
}
